<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <div class="mobileHeader">
                <h4>FAQs</h4>
                <mat-button-toggle-group>
                    <mat-button-toggle value="bold" (click)="toggleAccordition('table')">
                        <mat-icon> table_chart</mat-icon>
                    </mat-button-toggle>
                    <mat-button-toggle value="italic" (click)="toggleAccordition('accordition')">
                        <mat-icon> list_alt</mat-icon>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>

    </div>
    <div class="row" *ngIf="!showAsAccordition">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column w5">
                            {{i+1}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="question">
                        <th mat-header-cell *matHeaderCellDef>
                            Frage
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column w30" style="padding-right: 25px;">
                            {{element.title}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="answer">
                        <th mat-header-cell *matHeaderCellDef>
                            Antwort
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column w50">
                            <!-- <p>
                                {{element.description}}
                            </p> -->
                            <p [innerHTML]="element.description">
                            </p>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent" >
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <!--  *ngIf="!element.send" -->
                                <button mat-menu-item [routerLink]="['edit', element.publicId]">
                                    <span>Bearbeiten</span>
                                </button>

                                <button mat-menu-item (click)="deleteFaq(element)">
                                    <span>Löschen</span>
                                </button>

                            </mat-menu>
                        </td>
                    </ng-container>

                    <!-- <tr mat-header-row  *matHeaderRowDef="displayedColumns;  sticky: true"></tr> -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index">
                        <!-- TODO MAKE ROW CLICKABLE BUT ALSO MAKE MENU WORK AT THE SAME TIME -->
                        <!-- [routerLink]="['edit', row.publicId]" -->
                    </tr>
                </table>
                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState">Keine passenden Einträge
                    gefunden</span>



            </div>
            <button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['add']">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>

    <div class="row" *ngIf="showAsAccordition">
        <div class="col-sm-12">
            <mat-accordion>
                <mat-expansion-panel *ngFor="let item of this.dataSource.data">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{item.title }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <p [innerHTML]="item.description">
                        <!-- {{}} -->
                    </p>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>